import { useCookie } from 'nuxt/app'

export function useThemeCookie() {
  const appThemeCookie = useCookie('app_theme', {
    default: () => 'system',
  });

  const systemThemeCookie = useCookie('system_theme', {
    default: () => 'light',
  });

  const initialLoadCookie = useCookie('initial_load', {
    default: () => false,
  });




  const setAppTheme = (value: string) => {
    appThemeCookie.value = value;
    return value;
  };

  const setSystemTheme = (value: string) => {
    systemThemeCookie.value = value;
    return value;
  };

  const setInitialLoad = (value: boolean) => {
    initialLoadCookie.value = value;

    return value;
  };

  return { appThemeCookie, systemThemeCookie, initialLoadCookie, setAppTheme, setSystemTheme, setInitialLoad };
}